import { useState } from 'react';
import '../ordersCard.css';

const OrderCard = ({ order }) => {
  const {
    orderNumber,
    confirmationNumber,
    shippingRate,
    items,
    customerDetails,
    shippingAddress,
    billingAddress,
    createdAt,
    custEmail,
    Status,
    tracking
  } = order;

  
  const formattedDate = createdAt?.toDate
    ? createdAt.toDate().toLocaleString()
    : new Date(createdAt).toLocaleString();

  const [openSections, setOpenSections] = useState({
    customerDetails: false,
    shippingAddress: false,
    billingAddress: false,
    items: false,
  });

  const toggleSection = (sectionName) => {
    setOpenSections((prev) => ({
      ...prev,
      [sectionName]: !prev[sectionName],
    }));
  };
const getTrackingUrl = (trackingNum) => {
  if (!trackingNum) return '#';

  // Simple guessing by prefix/length
  if (/^\d{20,22}$/.test(trackingNum)) {
    return `https://tools.usps.com/go/TrackConfirmAction?tLabels=${trackingNum}`;
  }
  if (/^1Z/.test(trackingNum)) {
    return `https://www.ups.com/track?tracknum=${trackingNum}`;
  }
  if (/^\d{12,15}$/.test(trackingNum)) {
    return `https://www.fedex.com/fedextrack/?tracknumbers=${trackingNum}`;
  }

  // Default fallback (UPS)
  return `https://www.ups.com/track?tracknum=${trackingNum}`;
};

  return (
    <div className="order-card">
      <div className="order-header">
        <h5>{orderNumber}</h5>
        <h5>Confirmation: {confirmationNumber}</h5>
        <h6 style={{ display: "flex", alignItems: "center" }}>
  Status:&nbsp;<span style={{ color: "red" }}>{Status}</span>
</h6>
{tracking && (
  <h6>
    Tracking#: <a href={getTrackingUrl(tracking)} target="_blank" rel="noopener noreferrer">{tracking}</a>
  </h6>

)}
        <a href="/customer-review">
        <button className="review-btn">Leave a Review</button>
      </a>
       
        <div className="order-date">Placed on {formattedDate}</div>
      </div>

      {/* Customer Details */}
      <div className="section">
        <h4 onClick={() => toggleSection('customerDetails')}>
          Customer Details {openSections.customerDetails ? '▲' : '▼'}
        </h4>
        {openSections.customerDetails && (
          <div className="dropdown-content">
            <p><strong>Name:</strong> {customerDetails.name}</p>
            <p><strong>Email:</strong> {customerDetails.email}</p>
            <p><strong>Phone:</strong> {customerDetails.phone}</p>
          </div>
        )}
      </div>

      {/* Shipping Address */}
      <div className="section">
        <h4 onClick={() => toggleSection('shippingAddress')}>
          Shipping Address {openSections.shippingAddress ? '▲' : '▼'}
        </h4>
        {openSections.shippingAddress && (
          <address className="dropdown-content">
            {shippingAddress.name}<br />
            {shippingAddress.street1}<br />
            {shippingAddress.street2 && (<>{shippingAddress.street2}<br /></>)}
            {shippingAddress.city}, {shippingAddress.state} {shippingAddress.zip}<br />
            {shippingAddress.country}
          </address>
        )}
      </div>

      {/* Billing Address */}
      <div className="section">
        <h4 onClick={() => toggleSection('billingAddress')}>
          Billing Address {openSections.billingAddress ? '▲' : '▼'}
        </h4>
        {openSections.billingAddress && (
          <address className="dropdown-content">
            {billingAddress.street1}<br />
            {billingAddress.street2 && (<>{billingAddress.street2}<br /></>)}
            {billingAddress.city}, {billingAddress.state} {billingAddress.zip}<br />
            {billingAddress.country}
          </address>
        )}
      </div>

      {/* Items */}
      <div className="section">
        <h4 onClick={() => toggleSection('items')}>
          Items {openSections.items ? '▲' : '▼'}
        </h4>
        {openSections.items && (
          <div className="dropdown-content">
 <div className="table-wrapper">
    <table className="items-table">
      <thead>
        <tr>
          <th>Item</th>
          <th>Style</th>
          <th>Color</th>
          <th>Size</th>
          <th>Qty</th>
          <th>Price</th>
        </tr>
      </thead>
      <tbody>
        {items.map((item, i) => (
          <tr key={i}>
             <td>
  {item.finalUrl || item.url ? (
    <img src={item.finalUrl || item.url} alt="" style={{ width: 50 }} />
  ) : (
    <span>No image</span>
  )}
</td>
            <td>{item.style}</td>
            <td>{item.color}</td>
            <td>{item.size}</td>
            <td>{item.quantity}</td>
            <td>${parseFloat(item.price).toFixed(2)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
          </div>
        )}
      </div>

      {/* <div className="section shipping-rate">
        <strong>Shipping Rate:</strong> ${parseFloat(shippingRate).toFixed(2)}
      </div> */}
    </div>
  );
};

export default OrderCard;
